module.exports = __webpack_public_path__ + "img/plus-icon-blue.f700c749.svg";